import JsComponent from '../jsComponent/jsComponent.js';
import pigeon from '../../utilities/js/pigeon/pigeon.js';

class AccountSingleOrder extends JsComponent {
  constructor(mainElement, name = 'account-single-order') {
    super(mainElement, name);
    this.createClassNames(
      '__accordion'
    );

    this.singleOrderHandler = this.mainElement.querySelector(`.${this.classNames.accordion}`);
    this.orderId = this.mainElement.getAttribute('id');
    // this.bindEvents();
    this.getOrderDetails();
  }

  // bindEvents() {
  //   this.mainElement.addEventListener('click', event => {
  //     this.getOrderDetails(this.orderId);
  //   });
  // }

  getOrderDetails() {
    pigeon.publish('orderRequested:open', this.orderId);
  }
}

export default AccountSingleOrder;
